import React, {Fragment} from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import Settings from '../../Settings'

const StyledHamburger = styled(Link)`
  position: absolute;
  top: 10%;
  left: 10%;
  width: 3%;
  height: 4%;
  z-index: 1;

  &::before,
  &::after {
    content: '';
  }

  &::before,
  &::after,
  & > span {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 14%;
    background-color: ${Settings.themeColor};
  }

  &::before {
    top: 0;
  }

  & > span {
    top: 43%;
  }

  &::after {
    bottom: 0;
  }
`

export const Hamburger = ({to}) => {
  return (
    <Fragment>
      <StyledHamburger to={to}>
        <span />
      </StyledHamburger>
    </Fragment>
  )
}
